<template>
  <div
    ref="el"
    class="tiptap ProseMirror referenced-text"
    :class="{ 'is-reset-style': resetStyle }"
  />
</template>

<script lang="ts" setup>
import { onMounted, onUpdated, ref } from "vue"

import { EditorData } from "@/models/EditorData"

import InitComponent from "./InitComponent.vue"

const props = defineProps({
  html: {
    type: String,
    default: ""
  },
  resetStyle: {
    type: Boolean,
    default: false
  }
})

const el = ref<HTMLDivElement | null>(null)

function createElement() {
  if (!el.value) return

  el.value.innerHTML = ""
  const editorData = new EditorData({
    USER: InitComponent,
    PREVIOUS_TASK_OWNER: InitComponent,
    PROJECT: InitComponent,
    EPIC: InitComponent,
    IDEA: InitComponent,
    MILESTONE: InitComponent,
    TEAM: InitComponent,
    SPRINT: InitComponent,
    ITEM: InitComponent,
    TASK: InitComponent,
    FILE: InitComponent,
    FILE_LINK: InitComponent
  })
  editorData.setHtml(props.html)
  el.value.append(editorData.getHtmlElement())
}

onMounted(createElement)
onUpdated(createElement)
</script>
